import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "./store";
import { getTableDataThunk } from "../store/thunks/table.thunk";
import { tableConfiguration } from "../modules/ManageContract/constants";
import { getFailedClauseThunk } from "../modules/vscDashboard/store/dashboard.thunk";

interface ContractTableHookType {
  entity: string;
  action?: "GetContractStatus" | "GetBulkUploadStatus";
  toBeRetrieved?: number;
  apiProps: { sort_by?: {} };
  poling?: boolean;
}

const useContractTable = ({
  entity,
  apiProps,
  poling = false,
}: ContractTableHookType) => {
  const { data } = useAppSelector(
    (store) => store?.rootReducer?.tableInfoReducer
  );

  const tableData = data?.[entity]?.tableData;
  const loading = data?.[entity]?.loading;
  const error = data?.[entity]?.error;
  const page = data?.[entity]?.page || 1;
  const count = data?.[entity]?.toBeRetrieved || 10;
  const interval = useRef<any>();
  const [pageNumber, setPageNumber] = useState(page || 1);
  const [toBeRetrieved, setToBeRetrieved] = useState(
    count
      ? count
      : tableConfiguration[entity]?.toBeRetrived
      ? tableConfiguration[entity]?.toBeRetrived
      : 10
  );
  const keepPoling = poling;

  const dispatch = useAppDispatch();

  const updateTableDataAfterApiCall = async () => {
    await dispatch(
      getTableDataThunk(entity, pageNumber, toBeRetrieved, apiProps)
    );
  };

  useEffect(() => {
    dispatch(getTableDataThunk(entity, pageNumber, toBeRetrieved, apiProps));
    dispatch(getFailedClauseThunk());
    if (keepPoling) {
      interval.current = setInterval(() => {
        dispatch(
          getTableDataThunk(entity, pageNumber, toBeRetrieved, apiProps)
        );
        dispatch(getFailedClauseThunk());
      }, tableConfiguration?.[entity]?.polingInterval);
    }

    return () => {
      clearInterval(interval.current);
    };
  }, [pageNumber, toBeRetrieved, keepPoling, dispatch]);

  return [
    tableData,
    pageNumber,
    setPageNumber,
    toBeRetrieved,
    setToBeRetrieved,
    loading,
    error,
    updateTableDataAfterApiCall,
  ];
};

export default useContractTable;
